var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBreadCrumbIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.719935 18.7601C0.650212 18.6841 0.5949 18.5938 0.557161 18.4945C0.519423 18.3952 0.5 18.2887 0.5 18.1812C0.5 18.0737 0.519423 17.9672 0.557161 17.8679C0.5949 17.7686 0.650212 17.6784 0.719935 17.6024L7.68933 9.99991L0.719935 2.39742C0.579224 2.2439 0.500172 2.03569 0.500172 1.81859C0.500172 1.60148 0.579224 1.39327 0.719935 1.23976C0.860647 1.08624 1.05149 1 1.25049 1C1.44949 1 1.64034 1.08624 1.78105 1.23976L9.28006 9.42108C9.34979 9.49706 9.4051 9.58729 9.44284 9.68661C9.48058 9.78593 9.5 9.89239 9.5 9.99991C9.5 10.1074 9.48058 10.2139 9.44284 10.3132C9.4051 10.4125 9.34979 10.5028 9.28006 10.5787L1.78105 18.7601C1.7114 18.8361 1.6287 18.8965 1.53766 18.9376C1.44662 18.9788 1.34904 19 1.25049 19C1.15194 19 1.05436 18.9788 0.963324 18.9376C0.872287 18.8965 0.789581 18.8361 0.719935 18.7601Z",
    fill: "black",
    stroke: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadCrumbIcon);
export default __webpack_public_path__ + "static/media/breadCrumbIcon.89f353f7cef126a9fa79c9ce7340e4eb.svg";
export { ForwardRef as ReactComponent };